(function ($) {

    // remove the dev license warning to improve our development experience
    $(document).ready(function () {
        $('div>strong:contains("Dev License:")').parent('div').remove();
        $('div>p:contains("Powered by ")').remove();
        $('label[for="inputAttachments"]').parent('div').remove();

        const $mobileMenuToggles = $('[data-mobile-menu-toggle]');

        if ($mobileMenuToggles.length) {
            const getMobileMenu = function ($toggle) {
                return $('#' + $toggle.attr('aria-controls'));
            };

            const closeMobileSubmenus = function ($menu) {
                $menu.find('[data-mobile-submenu-toggle]').attr('aria-expanded', 'false');
                $menu.find('.mobile-menu__submenu').prop('hidden', true);
            };

            const setMobileMenuState = function ($toggle, isOpen) {
                const $menu = getMobileMenu($toggle);

                if (!$menu.length) {
                    return;
                }

                $menu.toggleClass('is-open', isOpen).attr('aria-hidden', isOpen ? 'false' : 'true');
                $toggle.toggleClass('is-open', isOpen).attr('aria-expanded', isOpen ? 'true' : 'false');

                if (!isOpen) {
                    closeMobileSubmenus($menu);
                }
            };

            const closeAllMobileMenus = function () {
                $mobileMenuToggles.each(function () {
                    setMobileMenuState($(this), false);
                });
            };

            $mobileMenuToggles.on('click', function (e) {
                e.preventDefault();

                const $toggle = $(this);
                const $menu = getMobileMenu($toggle);
                const isOpen = $menu.hasClass('is-open');

                closeAllMobileMenus();
                setMobileMenuState($toggle, !isOpen);
            });

            $('.mobile-menu').on('click', '[data-mobile-submenu-toggle]', function (e) {
                e.preventDefault();

                const $toggle = $(this);
                const $submenu = $('#' + $toggle.attr('aria-controls'));
                const isOpen = $toggle.attr('aria-expanded') === 'true';

                $toggle.attr('aria-expanded', isOpen ? 'false' : 'true');
                $submenu.prop('hidden', isOpen);
            });

            $('.mobile-menu').on('click', 'a', function () {
                closeAllMobileMenus();
            });

            $(document).on('click', function (e) {
                if (!$('.mobile-menu.is-open').length) {
                    return;
                }

                const isInsideHeader = $(e.target).closest('.site-header').length > 0;

                if (!isInsideHeader) {
                    closeAllMobileMenus();
                }
            });

            $(document).on('keydown', function (e) {
                if (e.key === 'Escape' && $('.mobile-menu.is-open').length) {
                    const $openToggle = $mobileMenuToggles.filter('.is-open').first();

                    closeAllMobileMenus();
                    $openToggle.trigger('focus');
                }
            });

            $(window).on('resize', function () {
                if (window.matchMedia('(min-width: 1300px)').matches) {
                    closeAllMobileMenus();
                }
            });
        }

        let $template = $('#domainSearchResultTemplate').clone();
        $('#domainSearchResultTemplate').remove();

        let loadingStackCount = 0;

        const setLoadingIcon = function ($btn, count) {
            if (count) {
                if ($btn.find('.loading-icon').length === 0) {
                    $btn.prepend('<i class="loading-icon fa fa-spinner fa-spin mr-1"></i>');
                    $btn.find('i:not(.loading-icon)').hide();
                }
            } else {
                $btn.find('.loading-icon').remove();
                $btn.find('i').show();
            }
        };

        // Check if the "domain" parameter exists in the URL
        const urlParams = new URLSearchParams(window.location.search);
        const domainParam = urlParams.get('domain');

        $('#nuagerieDomainChecker, #frmDomainChecker').submit(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $form = $(this);
            let $result = $('#domainSearchResults');

            // remove previous list
            $result.find('>*:not(#domainSearchResultTemplate)>*').remove();

            // hide previous errors
            $form.find('.invalid-feedback').hide();

            // loading spinner
            $form.find('.loading-icon').show();

            $result.find('#domainSearchResultsTitle').hide();

            const loadingStack = function (count) {
                loadingStackCount += count;
                setLoadingIcon($form.find('button'), loadingStackCount);
            }

            const injectDomain = function (type, domain) {
                $clonedTemplate = $template.clone();

                if (type === 'domain') {
                    $clonedTemplate.find('>').addClass('shadow mb-1 border-primary')
                    $clonedTemplate.find('.domain-name-main').show();
                }
                if (type === 'spotlight') {
                }
                if (type === 'suggestion') {
                    $clonedTemplate.find('.domain-name-suggestion').show();
                }

                if (domain.isRegistered) {
                }

                if (domain.isAvailable) {
                    $clonedTemplate.find('.domain-add-cart-btn').show();
                    $clonedTemplate.find('.domain-add-cart-btn').attr('data-domain', domain.domainName);
                    $clonedTemplate.find('.domain-unavailable-btn').hide();
                } else {
                    $clonedTemplate.find('>').addClass('text-muted bg-light');
                    $clonedTemplate.find('.domain-name').addClass('text-line-through');
                    $clonedTemplate.find('.domain-price').hide();
                    $clonedTemplate.find('.domain-add-cart-btn').hide();
                    $clonedTemplate.find('.domain-unavailable-btn').show();
                }

                let mainDomainHtml = $clonedTemplate.html();
                // mainDomainHtml = mainDomainHtml.replace('[domainName]', domain.domainName);
                mainDomainHtml = mainDomainHtml.replace('[tld]', domain.tld);
                mainDomainHtml = mainDomainHtml.replace('[sld]', domain.sld);
                mainDomainHtml = mainDomainHtml.replace('[pricing]', domain.pricing[1].register);

                if (type === 'domain') {
                    $('#domainSearchMainResults').append(mainDomainHtml);
                }
                if (type === 'spotlight') {
                    $('#domainSearchSpotlightResults').append(mainDomainHtml);
                }
                if (type === 'suggestion') {
                    $('#domainSearchSuggestionResults').append(mainDomainHtml);
                }

                $result.find('#domainSearchResultsTitle').show();
            }

            loadingStack(1);
            WHMCS.http.jqClient.post(WHMCS.utils.getRouteUrl("/domain/check"), $form.serialize() + "&type=domain", "json").done(function (data) {
                loadingStack(-1);
                if (!data || data.result.length === 0 || data.result.error) {
                    $form.find('.invalid-feedback').show();
                    return;
                }

                let domain = data.result[0];

                // if the user provided an invalid domain, make it valid and try again
                if (!domain.isValidDomain) {
                    $form.find('.invalid-feedback').show();
                }

                if (domain.isValidDomain) {
                    injectDomain('domain', domain);
                }
            }).fail(function () {
                loadingStack(-1);
            });

            loadingStack(1);
            WHMCS.http.jqClient.post(WHMCS.utils.getRouteUrl("/domain/check"), $form.serialize() + "&type=spotlight", "json").done(function (data) {
                loadingStack(-1);
                if (!data || data.result.length === 0 || data.result.error) {
                    return;
                }

                $.each(data.result, function (index, domain) {
                    injectDomain('spotlight', domain);
                });
            }).fail(function () {
                loadingStack(-1);
            });

            loadingStack(1);
            WHMCS.http.jqClient.post(WHMCS.utils.getRouteUrl("/domain/check"), $form.serialize() + "&type=suggestions", "json").done(function (data) {
                loadingStack(-1);
                if (!data || data.result.length === 0 || data.result.error) {
                    return;
                }

                $.each(data.result, function (index, domain) {
                    injectDomain('suggestion', domain);
                });
            }).fail(function () {
                loadingStack(-1);
            });
        })

        $('#domainSearchResults').on('click', '.domain-add-cart-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $btn = $(this);
            const $btnParent = $btn.parent();

            const loadingStack = function (count) {
                loadingStackCount += count;
                setLoadingIcon($btn, loadingStackCount);
            }

            const domain = $(this).data('domain');
            const data = {
                a: "addToCart",
                domain: domain,
                token: csrfToken,
                whois: "1",
                sideorder: 1,
                idnlanguage: '',
            };

            loadingStack(1);
            WHMCS.http.jqClient.post(whmcsBaseUrl + "/cart.php", data, "json").done(function (response) {
                loadingStack(-1);

                $btnParent.find('.domain-price').hide();
                $btnParent.find('.domain-add-cart-btn').hide();
                $btnParent.find('.domain-go-cart-btn').show();

            }).fail(function () {
                loadingStack(-1);
            });
        });


        if (domainParam) {
            // Sanitize the domain parameter to avoid injection
            const sanitizedDomain = $('<div>').text(domainParam).text();

            // Append the value to the input "domain"
            $('#nuagerieDomainChecker input[name="domain"]').val(sanitizedDomain);

            // Trigger the form submission
            $('#nuagerieDomainChecker').submit();

            // Scroll to the form
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $('#domainSearchResults').offset().top
                }, 555);
            }, 111)
        }

        /**
         * WHMCS Template /store/order.tpl
         */
        jQuery('form#addToCartForm').submit(function(e) {
            e.preventDefault();
            e.stopPropagation();

            const $btn = jQuery(this).find('button[type="submit"]');
            const $domain = jQuery(this).find('input[name="custom_domain"]');
            const $domainType = jQuery(this).find('input[name="domain_type"]');
            const $existingDomains = jQuery(this).find('input[name="existing_domains"]');
            const existingDomains = Object.values(JSON.parse(decodeURIComponent($existingDomains.val())));
            const $domainError = $domain.siblings('.invalid-feedback');
            let domainValue = $domain.val();

            // This function is for existing client who uses an existing domain in their account
            const setDomainType = function (domainValue) {
                let domainType = 'custom-domain';
                console.log(existingDomains, existingDomains);
                if (jQuery.inArray(domainValue, existingDomains) !== -1) {
                    domainType = 'existing-domain';
                } else {
                    const domainParts = domainValue.split('.');
                    if (domainParts.length > 2) {
                        const mainDomain = domainParts.slice(1).join('.');
                        if (jQuery.inArray(mainDomain, existingDomains) !== -1) {
                            domainType = 'sub-domain';
                        }
                    }
                }
                $domainType.val(domainType);
            }

            const loadingStack = function (count) {
                loadingStackCount += count;
                setLoadingIcon($btn, loadingStackCount);
            }

            loadingStack(1);
            WHMCS.http.jqClient.post(whmcsBaseUrl + '/cart/order/validate', 'domain=' + $domain.val(), 'json').done(function (response) {
                setDomainType(domainValue.toLowerCase());
                if (response.valid) {
                    $domainError.hide();
                    e.target.submit();
                } else {
                    loadingStack(-1);
                    $domainError.show();
                }
            }).fail(function () {
                loadingStack(-1);
            });
        });
    })
})(jQuery)
